import React from "react";
import VersionedLegalDocument from "./VersionedLegalDocument";

export default function CommunityRules() {
  return <VersionedLegalDocument documentType="community_rules" />;
}
